
import { defineComponent, PropType } from 'vue'
import { ElForm } from 'element-plus'
import { proximityWitnessRequest } from '@/requests/proximityWitness'
import JrButton from '@/components/jr-parts/JrButton.vue'
import { RequestHeaderProximityForm } from '@/types/forms'
import { MESSAGE_TYPE_CONFIRM, MESSAGE_TYPE_TOAST, addMessageQueue } from '@/plugins/messageQueue'
import Message from '@/services/message'
import { ProximityWitness } from '@/api'
import { useRouter } from 'vue-router'
import MessageService from '@/services/message'
import { ConstructionTypes } from '@/constants/enums'

export default defineComponent({
  name: 'OnSiteEditSend',
  components: {
    JrButton,
  },
  props: {
    proximityData: {
      type: Object as PropType<RequestHeaderProximityForm>,
      required: true,
    },
    formRef: {
      type: Object as PropType<InstanceType<typeof ElForm>>,
      required: false,
      default: null,
    },
    requestHeaderId: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()
    // 決定
    const register = () => {
      if (!props.formRef) {
        return
      }

      props.formRef.validate((valid) => {
        if (!valid) {
          return false
        }

        if (
          props.proximityData.proximity.proximity_id !== undefined &&
          props.proximityData.proximity.witness_date != null
        ) {
          const proximityId: number = props.proximityData.proximity.proximity_id
          const proximityResult: ProximityWitness = {
            construction_detail: props.proximityData.proximity.construction_detail,
            construction_type: props.proximityData.proximity.construction_type,
            construction_type_other:
              props.proximityData.proximity.construction_type == ConstructionTypes.OTHER
                ? props.proximityData.proximity.construction_type_other
                : null,
            construction_purpose: props.proximityData.proximity.construction_purpose,
            is_use_heavy: props.proximityData.proximity.is_use_heavy,
            use_heavy_remark: props.proximityData.proximity.is_use_heavy
              ? props.proximityData.proximity.use_heavy_remark
              : null,
            is_foundation_work: props.proximityData.proximity.is_foundation_work,
            foundation_work_remark: props.proximityData.proximity.is_foundation_work
              ? props.proximityData.proximity.foundation_work_remark
              : null,
            is_ground_completion: props.proximityData.proximity.is_ground_completion,
            is_use_out_land: props.proximityData.proximity.is_use_out_land,
            is_without_protective: props.proximityData.proximity.is_without_protective,
            without_protective_remark: props.proximityData.proximity.is_without_protective
              ? props.proximityData.proximity.without_protective_remark
              : null,
            start_plan_date: props.proximityData.proximity.start_plan_date,
            end_plan_date: props.proximityData.proximity.end_plan_date,
            witness_date: props.proximityData.proximity.witness_date,
            witness_remark: props.proximityData.proximity.witness_remark,
          }

          //確認ダイアログ表示
          addMessageQueue(
            MESSAGE_TYPE_CONFIRM,
            MessageService.bind(Message.codes.CONFIRM_OVERWRITE_SAVE, { target: '申請情報' }),
            async () => {
              //OKなら送信する
              //requestの作成
              const request = new proximityWitnessRequest(proximityId, proximityResult)

              // API実行
              await request.exec()

              // API成功
              if (request.success) {
                addMessageQueue(
                  MESSAGE_TYPE_TOAST,
                  MessageService.bind(MessageService.codes.SAVE_COMPLETE, { target: '現地立会結果' })
                )
                router.push({
                  name: 'ProximityDetail',
                  params: {
                    request_header_id: props.requestHeaderId,
                  },
                })
                return
              }
            }
          )
        }
      })
    }

    return {
      register,
    }
  },
})
